export function SettingsPage(): React.ReactElement {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
        <p className="text-gray-600">Configure your dashboard preferences</p>
      </div>

      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Preferences</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Default Currency
            </label>
            <select className="w-full max-w-xs border border-gray-300 rounded-md px-3 py-2">
              <option value="USD">USD ($)</option>
              <option value="EUR">EUR (&euro;)</option>
              <option value="GBP">GBP (&pound;)</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Target TRUE Discount (Min)
            </label>
            <input
              type="number"
              className="w-full max-w-xs border border-gray-300 rounded-md px-3 py-2"
              placeholder="40"
              defaultValue={40}
            />
            <p className="text-sm text-gray-500 mt-1">Minimum acceptable discount (%)</p>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Fee Drag Warning Threshold
            </label>
            <input
              type="number"
              className="w-full max-w-xs border border-gray-300 rounded-md px-3 py-2"
              placeholder="5"
              defaultValue={5}
            />
            <p className="text-sm text-gray-500 mt-1">
              Warn when fees exceed this % of NAV
            </p>
          </div>
        </div>
        <button className="mt-6 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors">
          Save Settings
        </button>
      </div>
    </div>
  );
}
